import kasperskyCoverImage from 'img/aside-promo-modal/kaspersky-cover.jpg';
import { IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { isViewContentOnly } from 'reactApp/appHelpers/settingsHelpers';
import { getFeatureAntivirusBannerPromo } from 'reactApp/modules/features/features.selectors';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { openAsidePromoModal } from 'reactApp/ui/AsidePromoModal/AsidePromoModal.helpers';
import { EPromoAction, sendSplashscreenAnalytics } from 'reactApp/utils/splashscreenAlertGa';
import { channel } from 'redux-saga';
import { put, select, take } from 'redux-saga/effects';

const ANTIVIRUS_PROMO_ID = 'antivirus';

const completePromoChannel = channel();

export function* initAntivirusAsidePromoModal() {
    const storage = getCurrentStorage(yield select());
    const alreadyClosed = storeHelper.getValue(ANTIVIRUS_PROMO_ID);
    const enabled = yield select(getFeatureAntivirusBannerPromo);

    if (storage === EStorageType.home && !alreadyClosed && enabled && !isViewContentOnly && !IS_WEBVIEW) {
        yield put(
            addPromoToShowQueue({
                type: EPromoType.antivirusAsidePromo,
                promoId: ANTIVIRUS_PROMO_ID,
                onShow: () => {
                    sendSplashscreenAnalytics({
                        action: EPromoAction.SHOW,
                        name: ANTIVIRUS_PROMO_ID,
                        source: storage,
                    });

                    storeHelper.markAsShown(ANTIVIRUS_PROMO_ID);
                },
                onClick: () => {
                    sendSplashscreenAnalytics({
                        action: EPromoAction.CLICK,
                        name: ANTIVIRUS_PROMO_ID,
                        source: storage,
                        name_button: 'disable-adv',
                    });

                    completePromoChannel.put(true);
                },
                onClose: () => {
                    sendSplashscreenAnalytics({
                        action: EPromoAction.CLOSE,
                        name: ANTIVIRUS_PROMO_ID,
                        source: storage,
                    });

                    completePromoChannel.put(true);
                },
            })
        );
    }
}

export function* showAntivirusAsidePromoModal() {
    const promo = PromoSelectors.getPromo(EPromoType.antivirusAsidePromo)(yield select());

    if (promo) {
        const { onShow, onClick, onClose } = promo;

        yield openAsidePromoModal({
            title: 'Ваши файлы под защитой',
            text: 'Всё, что хранится в Облаке, уже прошло проверку антивирусом Касперского',
            buttonText: 'Хорошо',
            imageUrl: kasperskyCoverImage,
            onShow,
            onClick,
            onClose,
        });
        yield put(promoShown(EPromoType.antivirusAsidePromo));

        while (true) {
            yield take(completePromoChannel);

            yield put(removePromo(EPromoType.antivirusAsidePromo));
            storeHelper.markAsShown(ANTIVIRUS_PROMO_ID);

            yield completePromoChannel.close();
        }
    }
}
